import { useEffect, useState } from 'react';

import { DateProvider } from '../../providers';

function useCountUp({ status, time }) {
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (!time || !time.length) return ['00', '00', '00'];
    const [hours, minutes, seconds] = DateProvider.getCountUpTime(time);

    return [hours, minutes, seconds];
  };

  const [hours, minutes, seconds] = getTime();

  return [hours, minutes, seconds];
}

export default useCountUp;
